import React from 'react'
import system from 'system-components'
import { graphql } from 'gatsby'

import 'typeface-lato'

import Layout from 'components/layout'
// import { Img } from 'components/ui'
import { WorkHero } from 'components/blocs'

const Project = system({
  is: 'section',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  minHeight: '70vh',
  mb: 1,
  p: 2,
  bg: '#fff',
  color: 'rgba(0,0,0,.8)',
  fontSize: 1,
})

Project.Media = system({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  w: [1, 1, 1, 2 / 3],
  p: 2,
})

Project.Info = system({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  w: [1, 1, 1, 1 / 3],
  p: 4,
})

Project.Title = system(
  {
    is: 'h2',
    mb: 1,
    fontSize: 5,
    fontFamily: 'Lato',
    fontWeight: 'bold',
  },
  'color',
)

Project.Meta = system({
  mb: 1,
})

Project.Description = system({
  is: 'p',
  // minHeight: '1em',
  my: 1,
})

Project.Tags = system({
  my: 1,
  display: 'flex',
  flexWrap: 'wrap',
  fontSize: 0,
})

Project.Tag = system({
  is: 'span',
  p: 1,
  mr: 1,
  my: 1,
  border: '1px solid currentColor',
  fontWeight: '600',
})

Project.Divider = system({
  is: 'hr',
  width: 1 / 5,
  borderBottom: '1px solid currentColor',
  my: 2,
})

const Embed = system(
  {
    ratio: 9 / 16,
  },
  'ratio',
  'space',
  'color',
  () => ({
    position: 'relative',
    overflow: 'hidden',
    '& > iframe': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      bottom: 0,
      left: 0,
      border: 0,
    },
  }),
)

Embed.displayName = 'Embed'

export const Work = ({ data }) => (
  <Layout>
    <WorkHero data={data} />
    {/* <Project bg="#a8e4bc" /> */}
    <Project id="aiwy-2014" bg="#94c0d1" color="#03426b">
      <Project.Info>
        <Project.Title color="#03426b">All I Wish You</Project.Title>
        <Project.Divider />
        <Project.Meta>YEAR: 2014</Project.Meta>
        <Project.Meta>CLIENT: BNP PARIBAS</Project.Meta>
        <Project.Meta>AGENCY: HUNGRY AND FOOLISH</Project.Meta>
        <Project.Divider />
        <Project.Description>
          All I Wish You is a website where people are invited to create and share their wishes with their friends or family.
        </Project.Description>
        <Project.Description>
          Each series of greetings creates a constellation of stars within the "3D space" unique graphic universe which can be explored by
          all in an immersive and interactive digital experience.
        </Project.Description>
        <Project.Divider />
        <Project.Tags>
          <Project.Tag>WebGL</Project.Tag>
          <Project.Tag>3D</Project.Tag>
          <Project.Tag>Ruby on Rails</Project.Tag>
          <Project.Tag>REST APIs</Project.Tag>
          <Project.Tag>Three.js</Project.Tag>
          <Project.Tag>jQuery</Project.Tag>
          <Project.Tag>Responsive</Project.Tag>
          <Project.Tag>Mobile</Project.Tag>
          <Project.Tag>Webcam API</Project.Tag>
          <Project.Tag>Twitter followers API</Project.Tag>
          <Project.Tag>Image Generation</Project.Tag>
          <Project.Tag>Social media (Post & Share)</Project.Tag>
        </Project.Tags>
      </Project.Info>
      <Project.Media>
        <Embed>
          {/* <iframe src="https://www.youtube.com/embed/Tky2Q6shaOM?rel=0&showinfo=0" frameBorder="0" allowFullScreen scrolling="no" /> */}
          {/* <iframe src="https://www.youtube.com/embed/l9c-Swad42s?rel=0&showinfo=0" frameBorder="0" allowFullScreen scrolling="no" /> */}
          <iframe
            title="All I Wish You - 2014"
            src="https://www.youtube.com/embed/k0wsTtSaZ00?rel=0&showinfo=0"
            frameBorder="0"
            allowFullScreen
            scrolling="no"
          />
        </Embed>
      </Project.Media>
    </Project>
    <Project id="aiwy-2015" bg="#d19499" color="#4a070d">
      <Project.Info>
        <Project.Title>All I Wish You In One Word</Project.Title>
        <Project.Divider />
        <Project.Meta>YEAR: 2015</Project.Meta>
        <Project.Meta>CLIENT: BNP PARIBAS</Project.Meta>
        <Project.Meta>AGENCY: HUNGRY AND FOOLISH</Project.Meta>
        <Project.Divider />
        <Project.Description>In a changing world, one word is enough to present our best wishes.</Project.Description>
        <Project.Divider />
        <Project.Tags>
          <Project.Tag>Ruby on Rails</Project.Tag>
          <Project.Tag>jQuery</Project.Tag>
          <Project.Tag>Fluid</Project.Tag>
          <Project.Tag>Responsive</Project.Tag>
          <Project.Tag>Mobile</Project.Tag>
          <Project.Tag>Infinite Scroll</Project.Tag>
          <Project.Tag>JS Animations</Project.Tag>
          <Project.Tag>Micro-interactions</Project.Tag>
          <Project.Tag>Image Generation</Project.Tag>
          <Project.Tag>Social media (Post & Share)</Project.Tag>
        </Project.Tags>
      </Project.Info>
      <Project.Media>
        <Embed>
          <iframe
            title="All I Wish You In One Word - 2015"
            src="https://www.youtube.com/embed/5C9W_d1n_YI?rel=0&showinfo=0"
            frameBorder="0"
            allowFullScreen
            scrolling="no"
          />
        </Embed>
      </Project.Media>
    </Project>
    <Project id="bebrave-2016" bg="#ffdfba" color="#4a070d">
      <Project.Info>
        <Project.Title>#BeBrave</Project.Title>
        <Project.Divider />
        <Project.Meta>YEAR: 2016</Project.Meta>
        <Project.Meta>CLIENT: Honor</Project.Meta>
        <Project.Meta>AGENCY: HUNGRY AND FOOLISH</Project.Meta>
        <Project.Divider />
        <Project.Description>Ready to break the codes? Prove it!</Project.Description>
        <Project.Divider />
        <Project.Tags>
          <Project.Tag>Ruby on Rails</Project.Tag>
          <Project.Tag>jQuery</Project.Tag>
          <Project.Tag>Responsive</Project.Tag>
          <Project.Tag>Mobile</Project.Tag>
          <Project.Tag>Twitter realtime streaming API</Project.Tag>
          <Project.Tag>Twitter upload media API</Project.Tag>
          <Project.Tag>Infinite Scroll</Project.Tag>
          <Project.Tag>Social media (Post & Share)</Project.Tag>
        </Project.Tags>
      </Project.Info>
      <Project.Media>
        <Embed>
          <iframe
            title="#BeBrave - 2016"
            src="https://www.youtube.com/embed/bbPnxlTNMj8?rel=0&showinfo=0"
            frameBorder="0"
            allowFullScreen
            scrolling="no"
          />
        </Embed>
      </Project.Media>
    </Project>
    {/* <Project bg="#ffdfba" />
    <Project bg="#ffb3ba" />
    <Project bg="#ffffba" />
    <Project bg="#baffc9" />
    <Project bg="#bae1ff" /> */}
  </Layout>
)

export default Work

// eslint-disable-next-line no-undef
export const pageQuery = graphql`
  fragment gridImage on ImageSharp {
    # fixed(width: 268, height: 202, duotone: { highlight: "#f00e2e", shadow: "#192550", opacity: 50 }, traceSVG: { color: "#328bff" }) {
    #   # ...GatsbyImageSharpFixed
    #   ...GatsbyImageSharpFixed_withWebp_tracedSVG
    # }
    fluid(maxWidth: 268, maxHeight: 202, quality: 90, traceSVG: { color: "black", background: "white" }) {
      ...GatsbyImageSharpFluid_withWebp_tracedSVG
    }
  }

  query IsoGridImageQuery {
    aiwy2014GridImg: file(relativePath: { eq: "2014/aiwy-2014.png" }) {
      childImageSharp {
        # imageSharp(originalName: { regex: "/aiwy-2014/" }) {
        ...gridImage
      }
    }
    aiwy2015GridImg: file(relativePath: { eq: "2015/aiwy-2015.png" }) {
      childImageSharp {
        # imageSharp(originalName: { regex: "/aiwy-2015/" }) {
        ...gridImage
      }
    }
    twoGridImg: file(relativePath: { eq: "2016/two-2016.png" }) {
      childImageSharp {
        # imageSharp(originalName: { regex: "/two-2016/" }) {
        ...gridImage
      }
    }
    arvalGridImg: file(relativePath: { eq: "2016/arval-2016.png" }) {
      childImageSharp {
        # imageSharp(originalName: { regex: "/arval-2016/" }) {
        ...gridImage
      }
    }
    honorGridImg: file(relativePath: { eq: "2016/honor-2016.png" }) {
      childImageSharp {
        # imageSharp(originalName: { regex: "/honor-2016/" }) {
        ...gridImage
      }
    }
    twmmGridImg: file(relativePath: { eq: "2017/twmm-2017.png" }) {
      childImageSharp {
        # imageSharp(originalName: { regex: "/twmm-2017/" }) {
        ...gridImage
      }
    }
  }
`
